import constants from "../../constants";
import CompanyLogo from "./CompanyLogo";
import BreadCrumbs from "./BreadCrumbs";
import React, { useContext } from "react";
import ProfileAvatar from "./ProfileAvatar";
import { useLocation } from "react-router-dom";
import { getDataFromStorage } from "../../util";
import HeaderHooks from "../../Hooks/HeaderHooks";
import Overlay from "../CommonComponents/Overlay";
import ReportHooks from "../../Hooks/ReportHooks";
import AlertContext from "../../context/AlertContext";
import SQLNavigator from "../Student/SQLPage/SQLNavigator";
import CodingHeader from "../Student/CodingPage/CodingHeader";
import HeaderRightNavSvgIcon from "../../Svg/HeaderRightNavSvgIcon";
import StudentTestPageProvider from "../../context/StudentTestPageContext";
import CodingPageLearnerSideBreadCrumbs from "../../Hooks/CodingPage/CodingPageLearnerSideBreadCrumbs";
import SuperAdminControls from "./SuperAdminControls";
import Search from "./Search";

export default function Header(Props) {
  const Alert = useContext(AlertContext);
  const isPreview = new URLSearchParams(window.location.search).get("mode") === "preview";

  const { hideCompanyName } = HeaderHooks();
  const { capitalizeFirstLetterOfEachWord } = ReportHooks();

  const { pathname } = useLocation();

  return (
    <div
      className={
        pathname === "/company"
          ? "headerDivForCompany"
          : pathname === "/registration"
          ? "headerDivForRegistration"
          : pathname === "/sandpack"
          ? "headerDivSandPack"
          : Props.component === "leftNav" || pathname === "/ainterview"
          ? "headerDivLeftNav"
          : pathname.includes("/u/") || pathname.includes("/public/")
          ? "headerDivPublicProfile"
          : "headerDiv"
      }
    >
      {!isPreview && <>
      <div className="headerDivLogo">
        {Props.component === "leftNav" && !Props.collapsed ? (
          <BreadCrumbs />
        ) : (
          <div className="headerDivLogoInnerDiv">
            <Overlay
              component={<CompanyLogo hideCompanyName={hideCompanyName()} component={"companyheader"}/>}
              title={
                hideCompanyName() && (
                  <div>
                    Batch Name :{" "}
                    {capitalizeFirstLetterOfEachWord(
                      sessionStorage.getItem("reportBatchName")
                    )}
                    <div>
                      LearningPath Name :{" "}
                      {capitalizeFirstLetterOfEachWord(
                        sessionStorage.getItem("aPathName")
                      )}
                    </div>
                  </div>
                )
              }
            />
            {hideCompanyName() && <CodingPageLearnerSideBreadCrumbs />}
          </div>
        )}
      </div>

      {pathname === "/mcq" ||
      pathname === "/sql" ||
      pathname === "/coding" ||
      pathname === "/ainterview" ||
      pathname === "/assignment" ? (
        <StudentTestPageProvider>
          {pathname === "/sql" && <SQLNavigator />}
          <CodingHeader />
        </StudentTestPageProvider>
      ) : (
        (pathname === "/company" ||
          (!pathname.includes("profile") && pathname !== "/sandpack") ||
          localStorage.getItem("batchType") ===
            constants.BATCH_TYPE.TESTING) && (
          <div className="headerDivBadges">
            {/* Show search only on the company selection page */}
            {pathname === "/company" && (
              <Search
                className="Searchbar"
                placeholder="Search Account..."
                value={Alert.companySearch || ""}
                onChange={(e) => Alert.setCompanySearch(e.target.value)}
              />
            // ) : (
            //   <Search className="Searchbar" />
            )}
            {getDataFromStorage("role") === constants.Roles.learner &&
              parseInt(localStorage.getItem("batchType")) !==
                constants.BATCH_TYPE.TESTING && <HeaderRightNavSvgIcon />}
            {Alert.showSupAdminControls && (
              <SuperAdminControls />
            )}
            {(pathname === "/company" || pathname === "/home") && <ProfileAvatar />}
          </div>
        )
      )}
      </>}
    </div>
  );
}